import { Component, OnInit } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionItemService } from 'src/Services/tracit.service';
import { ActionItemSearchModel } from 'src/Models/TracItModel';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-action-item-details-popup',
  templateUrl: './action-item-details-popup.component.html',
  styleUrls: ['./action-item-details-popup.component.css']
})
export class TracItActionItemDetailsPopupComponent implements OnInit {

  stateArray: any = [];
  carrierCategoryArray: any = [];
  actionItemSearchModel = new ActionItemSearchModel()

  tokenKey: string = '';
  companyId: number = 0;
  userId: number = 0;
  actionId: number = 0;
  updateId: number = 0;
  productId: number = 0;
  briefingId: number = 0;

  isAccordianShow: boolean = false;
  isHoverButtonClick: boolean = false;
  closeText = 'no';

  constructor(private readonly actionItemServices: ActionItemService,
    private readonly checkAuth: CheckAuth,
    private readonly activeModal: NgbActiveModal,
    private sessionStorageService: SessionStorageService) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.companyId = +sessionStorage.getItem("CompanyId");
    this.userId = +sessionStorage.getItem('UserId');
    this.productId = 4;
    this.updateId = +sessionStorage.getItem('updateId');
    this.actionId = +sessionStorage.getItem('actionId');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    sessionStorage.removeItem('productId');
    sessionStorage.removeItem('updateId');
    sessionStorage.removeItem('actionId');

    this.ActionItemSearchByIds(this.userId, this.updateId, this.actionId, this.briefingId);
  }


  ActionItemSearchByIds(userId: any, updateId: any, actionId: any, briefingId) {
    this.actionItemServices.ActionItemSearchByIds(this.tokenKey, userId, updateId, actionId, briefingId).subscribe(
      data => {

        if (data['status'] == 'Success') {
          this.actionItemSearchModel = data['actionItemSearchModel'];

          if (this.actionItemSearchModel.stateName != 'null' && typeof (this.actionItemSearchModel.stateName) != 'undefined') {
            this.stateArray = this.actionItemSearchModel.stateName.split(',');
          }
          if (this.actionItemSearchModel.carrierNames != 'null' && typeof (this.actionItemSearchModel.carrierNames) != 'undefined') {
            this.carrierCategoryArray = this.actionItemSearchModel.carrierNames.split(',');
          }
        }
      });
  }

  editComplete(event) {
    this.ActionItemSearchByIds(this.userId, this.updateId, this.actionId, this.briefingId);
    this.closeText = 'Reload';
  }
  deleteComplete() {
    this.activeModal.close('Reload')
  }

}
